module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bounceManage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("APP首页弹框管理\n\t\t"), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newBounce
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bounce"
  }, [_c('el-select', {
    on: {
      "change": _vm.neirong
    },
    model: {
      value: (_vm.bounceStatus),
      callback: function($$v) {
        _vm.bounceStatus = $$v
      },
      expression: "bounceStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部状态",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "草稿",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已发布",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已撤销",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.bounces
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "弹框ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "弹框图片",
      "width": "150"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('img', {
            attrs: {
              "src": _vm.row.imgUrl
            }
          })
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "弹框名称",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "allUnidFlag",
      "label": "目标校区",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "showStatus",
      "label": "弹出周期",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qizhiDate",
      "label": "起止日期",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "btn-box"
          }, [_c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.showDetail(_vm.row.id)
              }
            }
          }, [_vm._v("详情")]), _vm._v(" "), (_vm.row.status !== '已发布') ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editNew(_vm.row.id)
              }
            }
          }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.row.status == '已发布') ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.updateStatus(_vm.row, 1)
              }
            }
          }, [_vm._v("撤销发布")]) : _vm._e(), _vm._v(" "), (_vm.row.status !== '已发布') ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.updateStatus(_vm.row, 0)
              }
            }
          }, [_vm._v("发布")]) : _vm._e(), _vm._v(" "), (_vm.row.status !== '已发布') ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.deleteBounce(_vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11578399!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/bounce/bounceManage.vue
// module id = 945
// module chunks = 0